module.exports = new __parcel__URL__("NotFoundIcon.ab9d1086.svg").toString();